import { useState, useEffect } from "react";
export default function useMatchMedia() {
  const media = window.matchMedia('(max-width: 991px)');

  const [isMobile, setIsMobile] = useState(media.matches);
  const setMedia = (e) => setIsMobile(e.matches);

  useEffect(() => {
    media.addEventListener('change', setMedia);

    return () => {
      media.removeEventListener('change', setMedia);
    }
  }, []);

  return {
    isMobile,
  };
}
